import GeoJSON from "ol/format/GeoJSON.js";
import toTurf from "./toTurf";
import fromTurf from "./fromTurf";
import lineSlice from './lineSlice.js'
import lineIntersect from "./lineIntersect.js";
import turfLineString from "./turfLineString.js";
import turfPoint from "./turfPoint.js";
import turfLength from "@turf/length";
import turfAlong from "@turf/along";
import booleanPointInPolygon from "./booleanPointInPolygon.js";
import lineSplit from "./lineSplit.js";

export default function getIntersectLineTurf(line, poly, mapProjection) {
    var formatgeo = new GeoJSON();
    var lastinturf = toTurf(line, mapProjection, formatgeo);
    var nowinturf = toTurf(poly, mapProjection, formatgeo);
    var splitedlines = [];
    var splitedpointcoords = [];

    for (var i = 1; i < lastinturf.geometry.coordinates.length; i++) {
        var thiscooe = [];
        var coord1 = lastinturf.geometry.coordinates[i - 1];
        var coord2 = lastinturf.geometry.coordinates[i];
        var inters = lineIntersect(turfLineString([lastinturf.geometry.coordinates[i - 1], lastinturf.geometry.coordinates[i]]), nowinturf);
        inters.features.forEach((point) => {
            thiscooe.push(point.geometry.coordinates);
        });
        if (thiscooe.length > 1) {
            if (coord1[0] < coord2[0]) {
                thiscooe.sort(function (a, b) { return a[0] - b[0]; });
            } else if (coord1[0] > coord2[0]) {
                thiscooe.sort(function (a, b) { return b[0] - a[0]; });

            } else if (coord1[0] === coord2[0]) {
                if (coord1[1] < coord2[1]) {
                    thiscooe.sort(function (a, b) { return a[1] - b[1]; });

                } else if (coord1[1] > coord2[1]) {
                    thiscooe.sort(function (a, b) { return b[1] - a[1]; });

                }
            }
        }
        splitedpointcoords = splitedpointcoords.concat(thiscooe);
    }

    if (splitedpointcoords.length > 1) {
        splitedpointcoords.unshift(lastinturf.geometry.coordinates[0]);
        splitedpointcoords.push(lastinturf.geometry.coordinates[lastinturf.geometry.coordinates.length - 1]);
        for (var ij = 1; ij < splitedpointcoords.length; ij++) {
            let intersection1 = lineSlice(turfPoint(splitedpointcoords[ij - 1]), turfPoint(splitedpointcoords[ij]), lastinturf);
            var length = turfLength(intersection1);
            var along = turfAlong(intersection1, length / 2);
            if (booleanPointInPolygon(along, nowinturf)) {
                splitedlines.push(intersection1);
            }
        }
    } else if (splitedpointcoords.length === 1) {
        var split = lineSplit(lastinturf, turfPoint(splitedpointcoords[0]));

        for (var j = 0; j < split.features.length; j++) {
            //let intersection1 = lineSlice(turfPoint(split.features[j - 1]), turfPoint(split.features[j]), lastinturf);
            let intersection1 = split.features[j];
            var length1 = turfLength(intersection1);
            var along1 = turfAlong(intersection1, length1 / 2);

            if (booleanPointInPolygon(along1, nowinturf)) {
                splitedlines.push(intersection1);
            }
        }
    } else {
        let intersection1 = lastinturf;
        var length1 = turfLength(intersection1);
        var along1 = turfAlong(intersection1, length1 / 2);

        if (booleanPointInPolygon(along1, nowinturf)) {
            splitedlines.push(intersection1);
        }
    }

    var lines = [];

    for (var ii = 0; ii < splitedlines.length; ii++) {
        var interinol = fromTurf(splitedlines[ii], mapProjection, formatgeo);
        lines.push(interinol);
    }

    return lines;
}